import React from 'react';

import { CheckboxBare } from '@core/js/components/common/Fields/Checkbox/Checkbox';

import { clsx } from '@interlayer/js/app/utils/clsx.util';
import { withField } from '@interlayer/js/components/common/Fields/withField';

import { TCheckboxProps } from './buzz/types';

import style from './Checkbox.scss';

const CheckboxOriginal = withField(CheckboxBare);

export const Checkbox: React.FC<TCheckboxProps> = ({
    kind,
    type = 'checkbox',
    isTransparent,
    className,
    ...other
}) => (
    <CheckboxOriginal
        // @ts-ignore: remove after CheckboxOriginal is ts
        className={clsx(className, { [style.transparent]: kind === 'toggle' || isTransparent })}
        kind={kind}
        type={type}
        {...other}
    />
);

